<template>
  <b-button-group class="v-align" :class="positioningClass">
    <base-button v-for="button in buttons"
                 :class="marginButton"
                 :key="button.id"
                 :route="button.route"
                 :text="button.text"
                 :title="button.title"
                 :fa-class="button.faClass"
                 :fa-position="button.faPosition"
                 :bootstrap-class="button.bootstrapClass"
                 :deletion-data="button.deletionData"
                 @click="onClick(button)"
                 @needReload="$emit('needReload')"
    />

    <resend-email-modal v-if="displayResendEmailModal" @ok="onSuccessResendEmail" />

    <traveller-import-modal v-if="displayTravellerImportModal" @travellerImported="onTravellerImported" />

    <traveller-add v-if="displayTravellerAddModal" @input="addTraveller" />

    <traveller-edit v-if="displayTravellerAdminEditModal"
                    :traveller="traveller"
                    :company-input-fields="companyInputFields"
                    :traveller-input-fields="travellerInputFields"
                    @input="editTraveller"
    />
    <contingent-mass-edit v-if="displayContingentMassEditModal" :hotel-id="hotelId.toString()" @input="onMassEditDone"/>

    <b-modal v-if="displayResendEmailModal" id="successResendEmail" ref="success" ok-only>
      {{ successMessage }}
    </b-modal>

    <b-modal
      v-if="displayTravellerImportModal"
      id="successTravellerImport"
      ref="success"
      ok-only
      @hidden="refreshTravellers"
      @ok="refreshTravellers"
      @close="refreshTravellers"
    >
      <b-alert v-if="travellerEvent.show" :variant="travellerEvent.variant" class="col-12" show>
        <div v-if="travellerEvent.msg" v-html="travellerEvent.msg" />

        <div v-for="msg in travellerEvent.data">
          {{ msg }}
        </div>
      </b-alert>
    </b-modal>
  </b-button-group>
</template>

<script>
import bButtonGroup from 'bootstrap-vue/es/components/button-group/button-group'
import baseButton from '@/components/backoffice/button/base'
import { flexbox } from '@/utils/style'
import resendEmailModal from '@/components/backoffice/modal/resendEmail'
import travellerImportModal from '@/components/global/modal/travellerImport'
import SecurityAPI from '@/api/security'
import travellerAdd from '@/components/frontoffice/form/traveller/add'
import travellerEdit from '@/components/frontoffice/form/traveller/edit'
import contingentMassEdit from '@/components/frontoffice/form/contingent/massEdit'
import CommonApi from '@/api/commonApi'

export default {
  components: {
    bButtonGroup,
    baseButton,
    flexbox,
    resendEmailModal,
    travellerImportModal,
    travellerAdd,
    travellerEdit,
    contingentMassEdit
  },

  props: {
    buttons: {
      type: Array,
      required: true
    },
    positioningClues: Object
  },

  data () {
    return {
      commonApi: new CommonApi(),
      positioningClass: '',
      successMessage: null,
      displayResendEmailModal: false,
      displayTravellerImportModal: false,
      displayTravellerAddModal: false,
      displayTravellerAdminEditModal: false,
      displayContingentMassEditModal: false,
      travellerEvent: {},
      traveller: null,
      hotelId: null,
      companyInputFields: null,
      travellerInputFields: null,
      enabled: false,
      iconDisabled: 'check',
      titleDisabled: '_enable'
    }
  },

  async created () {
    if (this.positioningClues) {
      this.getButtonGroupClass(this.positioningClues.overall, this.positioningClues.position)
    }

    for (let button of this.buttons) {
      if (button.resend) this.displayResendEmailModal = true
      if (button.import) this.displayTravellerImportModal = true
      if (button.add) this.displayTravellerAddModal = true
      if (button.enable) {
        this.enabled = button.travellerData.entity.enabled
        if (!this.enabled) {
          button.faClass = this.iconDisabled
          button.title = this.titleDisabled
        }
      }
      if (button.massContingentsEdit) {
        this.hotelId = button.hotelId
        this.displayContingentMassEditModal = true
      }
    }
  },

  computed: {
    marginButton () {
      if (this.buttons.length > 1) {
        return 'mr-1'
      }
      return ''
    }
  },

  methods: {

    async onClick (button) {
      if (button.resend) {
        this.$bvModal.show('resend_email')
      } else if (button.name === 'impersonate' && button.email) {
        SecurityAPI.impersonate(button.email)
      } else if (button.name === 'disableBooking' && button.booking) {
        await this.commonApi.adminDisableBooking(button.booking).then(this.refresh)
      } else if (button.name === 'disableHotelRetrocession' && button.hotelRetrocession) {
        if (button.type === 'disable') {
          await this.commonApi.adminDisableHotelRetrocession(button.hotelRetrocession).then(this.refresh)
        } else {
          await this.commonApi.adminEnableHotelRetrocession(button.hotelRetrocession).then(this.refresh)
        }
      } else if (button.name === 'enableHotelRetrocession' && button.hotelRetrocession) {
        await this.commonApi.adminEnableHotelRetrocession(button.hotelRetrocession).then(this.refresh)
      } else if (button.name === 'massContingentsEdit') {
        this.hotelId = button.hotelId
        this.$bvModal.show('mass-contingents-edit')
      } else if (button.import) {
        this.$bvModal.show('import-travellers')
      } else if (button.add) {
        this.$bvModal.show('traveller-add')
      } else if (button.editAdmin) {
        this.traveller = button.travellerData.entity
        await this.commonApi.searchCompany(this.traveller.company.id).then(response => {
          this.companyInputFields = response.data.data.booking_input_fields
          this.displayTravellerAdminEditModal = true
        })
        this.$bvModal.show('traveller-edit')
      } else if (button.enable) {
        this.onSwapDisable(button.travellerData.entity.id)
      } else if (button.back && this.$store.getters['security/isHotel']) {
        await this.$router.push({
          path: '/'
        })
      }
    },

    onSwapDisable (travellerId) {
      this.commonApi.swapTravellerEnabled(travellerId)
        .then(response => {
          if (response['data']['success']) {
            this.refreshTravellers()
          }
        })
    },

    onSuccessResendEmail (event) {
      this.successMessage = event
      this.$bvModal.show('successResendEmail')
    },

    addTraveller (event) {
      this.$bvModal.hide('traveller-add')
      this.travellerEvent = event
      if (this.travellerEvent) this.refreshTravellers()
    },

    editTraveller (event) {
      this.$bvModal.hide('traveller-edit')
      this.travellerEvent = event
      if (this.travellerEvent) this.refreshTravellers()
    },

    onTravellerImported (event) {
      this.$bvModal.hide('import-travellers')
      this.travellerEvent = event
      this.$bvModal.show('successTravellerImport')
    },

    onMassEditDone (event) {
      this.$bvModal.hide('mass-contingents-edit')
      this.refresh()
    },

    refreshTravellers (event) {
      this.$router.go()
    },

    refresh () {
      this.$router.go()
    },

    getButtonGroupClass (overall, positionInGroup) {
      let ret = ' float-left ' + flexbox.position.justifyContent(positionInGroup)

      switch (positionInGroup) {
        case 'middle':
          if (!overall.left) {
            ret += ' '
          }
          break
        case 'right':
          if (!overall.left && !overall.middle) {
            ret += ' float-right'
          } else if (!overall.middle) {
            ret += ' float-right'
          }
          break
      }

      this.positioningClass = ret
    }
  }
}
</script>
